import { NavLink } from "react-router-dom";

const sections = [
  { to: "/admin/about", label: "About page" },
  { to: "/admin/presskit", label: "Press Kit copy" },
  { to: "/admin/media", label: "Media library" },
  { to: "/admin/media-kit", label: "Media Kit" },
];

export default function AdminLayout({ children, email, onSignOut, status }) {
  return (
    <main className="admin-page">
      <div className="admin-shell">
        <header className="admin-header">
          <div><p className="admin-kicker">Website management</p><h1>Admin</h1></div>
          <div className="admin-account"><span>{email}</span><button type="button" onClick={onSignOut}>Sign out</button></div>
        </header>

        <nav className="admin-nav" aria-label="Admin navigation">
          {sections.map((section) => (
            <NavLink key={section.to} to={section.to} className={({ isActive }) => isActive ? "active" : undefined}>
              {section.label}
            </NavLink>
          ))}
        </nav>

        {status.message && <p className={`admin-message ${status.type}`} role="status" aria-live="polite">{status.message}</p>}
        <div className="admin-workspace">{children}</div>
      </div>
    </main>
  );
}
